// Needs an extra file since this causes circular dependencies if put into Repositories.tsx
export const DEFAULT_PAGE_SIZE = 20;
